<div>
    <div class="modal-header">
        <div class="col-md-10">
            <h5 class="modal-title text-start"><strong>Detalhes da operação SCR</strong></h5>
        </div>
        <div class="col-md-2">
            <button type="button" class="btn-close float-end" (click)="cancelar()" aria-label="Close"></button>
        </div>

    </div>
    <div class="modal-body">

        <div class="container-fluid" *ngIf="operacaoScr; else carregando">
            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Data de Contratação:</b></label>
                    <input type="text" class="form-control" name="dataContrato"
                        [ngModel]="operacaoScr.dataContrato | date:'dd/MM/yyyy' " disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>Data de Vencimento:</b></label>
                    <input type="text" class="form-control" name="dataVencimento"
                        [ngModel]="operacaoScr.dataVencimento | date:'dd/MM/yyyy' " disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>Dias em atraso:</b></label>
                    <input type="text" class="form-control" name="diasAtraso" [ngModel]="operacaoScr.diasAtraso"
                        disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>Tipo do Cliente:</b></label>
                    <input type="text" class="form-control" name="tipoCliente" [ngModel]="operacaoScr.tipoCliente"
                        disabled />
                </div>

                <div class="bn-form-group col-md-6">
                    <label><b>Valor Vincenda:</b></label>
                    <input type="text"  bnMask="DECIMAL" class="form-control" name="vicenda" [ngModel]="operacaoScr.valorAtivaVencer" disabled />
                  </div>
              
                  <div class="bn-form-group col-md-6">
                    <label><b>Valor Vencida:</b></label>
                    <input type="text"  bnMask="DECIMAL" class="form-control" name="vencida" [ngModel]="operacaoScr.valorAtivaVencida" disabled />
                  </div>

            </div>
            <div class="row">
                <div class="bn-form-group col-md-6">
                    <label><b>Modalidade:</b></label>
                    <input type="text" class="form-control" name="modalidade" [ngModel]="operacaoScr.modalidade"
                        disabled />
                </div>

                <div class="bn-form-group col-md-6">
                    <label><b>IPOC:</b></label>
                    <input type="text" class="form-control" name="ipoc" [ngModel]="operacaoScr.ipoc" disabled />
                </div>

            </div>
            <div class="table-responsive mt-3">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <!--th scope="col">Id</th-->
                            <th scope="col">Tipo de Vértice</th>
                            <th scope="col">Valor</th>
                        <tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let vertice of operacaoScr.vertices">
                            <!--td>{{ vertice.id }}</td-->
                            <td>{{ formataTipoVerticeScr(vertice) }} </td>
                            <td>{{ vertice.valorVertice | bnMask: 'MOEDA' }}</td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <div class="row" *ngIf="solicitacaoHonraArquivo.trocaIpoc;else carregando">

            <div class="bn-form-group col-md-3" *ngIf="solicitacaoHonraArquivo?.arquivoScrUtilizadoNaValidacao">
                <label><b>Data Base:</b></label>
                <input type="text" class="form-control" name="referencia"
                    [ngModel]="solicitacaoHonraArquivo?.arquivoScrUtilizadoNaValidacao?.referencia+'-01' | date:'MM/yyyy' " disabled />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Data de validação:</b></label>
                <input type="text" class="form-control" name="dataContrato"
                    [ngModel]="solicitacaoHonraArquivo?.dataValidacao | date:'dd/MM/yyyy' " disabled />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Tipo de Validação:</b></label>
                <input type="text" class="form-control" name="tipoValidacao"
                    [ngModel]="solicitacaoHonraArquivo.tipoValidacao=='E' ? 'Envio Solicitação' : 'Processamento' " disabled />
            </div>

            <div class="bn-form-group col-md-3" *ngIf="solicitacaoHonraArquivo?.arquivoScrUtilizadoNaValidacao">
                <label><b>Ativo:</b></label>
                <input type="text" class="form-control" name="tipoValidacao"
                    [ngModel]="solicitacaoHonraArquivo.arquivoScrUtilizadoNaValidacao?.ativo ? 'Sim' : 'Não' " disabled />
            </div>

            <!--<div class="bn-form-group col-12">
                <label><b>IPOC Antigo:</b></label>
                <input type="text" class="form-control" name="ipocAntigo" [ngModel]="solicitacaoHonraArquivo.ipocAntigo"
                    disabled />
            </div>-->

            <div class="bn-form-group col-12">
                <label><b>IPOC Novo:</b></label>
                <input type="text" class="form-control" name="ipocNovo" [ngModel]="solicitacaoHonraArquivo.ipocNovo"
                    disabled />
            </div>



        </div>

    </div>

    <div class="alert alert-info" *ngIf="showMessage">
        Não foram encontradas SCRs associadas para esta operacão.
    </div>

</div>

<ng-template #carregando *ngIf="!showMessage">
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>